module.exports = __webpack_public_path__ + "img/logo8.19c6fa04.png";